import { Route, Switch } from 'react-router-dom';

import { FavoritesContextProvider } from './context/Favorites';
import { RatingsContextProvider } from './context/Ratings';
import { ShoppingCartContextProvider } from './context/ShoppingCart';
import CreateSweet from './pages/create-sweet/CreateSweet';
import { Details } from './pages/details/Details';
import { Favorites } from './pages/favorites/Favorites';
import ShoppingCart from './pages/shopping-cart/ShoppingCart';
import SweetShop from './pages/sweet-shop/SweetShop';
import ToyShop from './pages/toy-shop/ToyShop';
import ToyTemplate from './templates/ToyTemplate';

export default function ToyApp() {
  return (
    <ShoppingCartContextProvider>
      <FavoritesContextProvider>
        <RatingsContextProvider>
          <ToyTemplate>
            <Switch>
              <Route exact path="/toy-shop" component={ToyShop} />
              <Route exact path="/toy-shop/sweet" component={SweetShop} />
              <Route exact path="/toy-shop/sweet/new" component={CreateSweet} />
              <Route exact path="/toy-shop/cart" component={ShoppingCart} />
              <Route exact path="/toy-shop/favorites" component={Favorites} />
              <Route exact path="/toy-shop/sweet/:id" component={Details} />
            </Switch>
          </ToyTemplate>
        </RatingsContextProvider>
      </FavoritesContextProvider>
    </ShoppingCartContextProvider>
  );
}
